<template>
  <div>
    <v-treeview open-all :items="pattern" style="text-align: left; padding-left: 50px">
      <template #append="{item}">
        <v-row no-gutters class="align-center">
          <v-col v-if="item.selectItems" align-self="start">
            <v-autocomplete
              class="treeview-type-select"
              dense
              hide-details
              :value="item.value"
              @change="item.value = $event"
              :items="item.selectItems"
              :rules="[v => !!v || v == '0' || 'rules.required']"
              :placeholder="$i18n.t('dialog.body.selectType')"
              item-value="id"
              :item-text="getItemText(item)"
              :menu-props="{ offsetY: true }"
              style="background-color: rgb(0,145,234)"
              @input="$emit('input', $event)"
              :append-icon="'$dropdown'"
            >
              <template #selection="{ item }">
                <div class="sidebar-status-selection">
                  {{ item ? getItemValueText(item) : 'Wybierz typ' }}
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col style="min-width: 32px">
            <v-icon v-if="item && hasDelete(item)" color="error" @click="handleDelete(item)">
              mdi-close
            </v-icon>
          </v-col>
          <v-col style="min-width: 32px; transform: translateX(-27vw)">
            <v-btn v-if="item && hasAdd(item)" fab color="success" @click="addChild(item)" x-small>
              <v-icon color="white" :size="15">
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'ZDMLanternPatternTreeview',
  props: {
    pattern: {
      type: Array,
      default: () => [],
    },
    poleTypeFeatures: {
      type: Array,
      default: () => [],
    },
    pickArmFeatures: {
      type: Array,
      default: () => [],
    },
    headTypeFeatures: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dataSourcesFeatures: get('layers/dataSourcesFeatures'),
    pickArmDisplayName: get('admin/modulesMapping@zdm_data.catalogs.pick_arm.display_attribute_name'),
    headDisplayName: get('admin/modulesMapping@zdm_data.catalogs.head.display_attribute_name'),
    poleDisplayName: get('admin/modulesMapping@zdm_data.catalogs.pole.display_attribute_name'),
  },
  methods: {
    getItemValueText(item) {
      if (item[this.headDisplayName]) {
        return item[this.headDisplayName];
      } else if (item[this.pickArmDisplayName]) {
        return item[this.pickArmDisplayName];
      } else if (item[this.poleDisplayName]) {
        return item[this.poleDisplayName];
      }
    },
    getItemText(item) {
      if (item.level === 4) {
        return this.headDisplayName;
      } else if (item.level === 3) {
        return this.pickArmDisplayName;
      } else if (item.level === 2) {
        return this.poleDisplayName;
      }
    },
    hasAdd(item) {
      if (item.level === 4 || item.level === 1) {
        return false;
      } else {
        if (item.level === 2) {
          return this.pattern[0].children[0].children.length < 2;
        } else {
          return true;
        }
      }
    },
    hasDelete(item) {
      if (item.level === 2 || item.level === 1) {
        return false;
      } else {
        return item.index !== 0;
      }
    },
    addChild(i) {
      if (i.level === 3) {
        if (!i.children) {
          i.children = [
            {
              name: this.$i18n.t('admin.light_head'),
              level: 4,
              parentIndex: i.index,
              index: 0,
              selectItems: this.headTypeFeatures,
            },
          ];
        }
        i.children = [
          ...i.children,
          {
            name: this.$i18n.t('admin.light_head'),
            level: 4,
            parentIndex: i.index,
            index: i.children.length,
            selectItems: this.headTypeFeatures,
          },
        ];
      } else if (i.level === 2) {
        i.children = [
          ...i.children,
          {
            name: this.$i18n.t('admin.pick_arm_secondary'),
            level: 3,
            parentIndex: i.index,
            index: i.children.length,
            selectItems: this.pickArmFeatures,
            children: [
              {
                name: this.$i18n.t('admin.light_head'),
                level: 4,
                parentIndex: i.children.length,
                index: 0,
                selectItems: this.headTypeFeatures,
              },
            ],
          },
        ];
      }
    },
    handleDelete(item) {
      if (item.level === 3) {
        let parent = this.pattern[0].children[0];
        parent.children = parent.children.filter(child => child.index !== item.index);
      } else if (item.level === 4) {
        let parent = this.pattern[0].children[0].children[item.parentIndex];
        parent.children = parent.children.filter(child => child.index !== item.index);
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {
    color: white;
  }
}
.treeview-type-select {
  border-radius: 4px;
  padding: 0 8px;
  max-width: fit-content;
  min-width: 130px;
}
.sidebar-status-item {
  padding: 0 4px;
  border-radius: 4px;
}
.sidebar-status-selection {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  color: white;
}
::v-deep .v-list-item {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 11px !important;
  line-height: 20px;
  min-height: 30px;
  padding: 0 8px;
}
::v-deep .v-input__slot::after {
  display: none;
}
::v-deep .v-input__slot::before {
  display: none;
}
::v-deep .v-input__icon .v-icon {
  color: white !important;
}
.v-select--is-menu-active {
  ::v-deep .v-icon {
    padding-bottom: 0px !important;
  }
}
</style>
